<template>
    <div>
        <form v-if="message.type != 'success'" @submit.prevent="submitForm" id="eventsForm">
            <div class="grid gap-6 mb-6 md:grid-cols-2">
                <div class="col-span-2">
                    <label for="location_name" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        {{ $t("Location Name") }}
                    </label>
                    <input type="text" id="location_name" v-model="form.name" name="name"
                        class="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg block w-full p-2.5 dark:bg-neutral-700 dark:border-neutral-600 dark:placeholder-gray-400 dark:text-white"
                        placeholder="Location Name" required />
                    <!-- Error message -->
                    <p v-if="hasError('name')" class="text-red-500 text-sm mt-1">
                        {{ getError('name') }}
                    </p>
                </div>

                <div class="col-span-2">
                    <label for="google_maps_url" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        {{ $t("Google Maps URL") }}
                    </label>
                    <input type="url" id="google_maps_url" v-model="form.maps_url" name="google_maps_url"
                        class="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg block w-full p-2.5 dark:bg-neutral-700 dark:border-neutral-600 dark:placeholder-gray-400 dark:text-white"
                        placeholder="Google Maps URL" />
                    <!-- Error message -->
                    <p v-if="hasError('google_maps_url')" class="text-red-500 text-sm mt-1">
                        {{ getError('google_maps_url') }}
                    </p>
                </div>

                <div>
                    <label for="street" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        {{ $t("Street") }}
                    </label>
                    <input type="text" id="street" v-model="form.street" name="street"
                        class="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg block w-full p-2.5 dark:bg-neutral-700 dark:border-neutral-600 dark:placeholder-gray-400 dark:text-white"
                        placeholder="Street" />
                    <!-- Error message -->
                    <p v-if="hasError('street')" class="text-red-500 text-sm mt-1">
                        {{ getError('street') }}
                    </p>
                </div>

                <div>
                    <label for="city" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        {{ $t("City") }}
                    </label>
                    <input type="text" id="city" v-model="form.city" name="city"
                        class="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg block w-full p-2.5 dark:bg-neutral-700 dark:border-neutral-600 dark:placeholder-gray-400 dark:text-white"
                        placeholder="City" />
                    <!-- Error message -->
                    <p v-if="hasError('city')" class="text-red-500 text-sm mt-1">
                        {{ getError('city') }}
                    </p>
                </div>

                <div>
                    <label for="postcode" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        {{ $t("Postcode") }}
                    </label>
                    <input type="text" id="postcode" v-model="form.postcode" name="postcode"
                        class="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg block w-full p-2.5 dark:bg-neutral-700 dark:border-neutral-600 dark:placeholder-gray-400 dark:text-white"
                        placeholder="Postcode" />
                    <!-- Error message -->
                    <p v-if="hasError('postcode')" class="text-red-500 text-sm mt-1">
                        {{ getError('postcode') }}
                    </p>
                </div>

                <div>
                    <label for="country" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        {{ $t("Country") }} (NL, EN, DE)
                    </label>
                    <input type="text" id="country" v-model="form.country" name="country"
                        class="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg block w-full p-2.5 dark:bg-neutral-700 dark:border-neutral-600 dark:placeholder-gray-400 dark:text-white"
                        placeholder="Country" />
                    <!-- Error message -->
                    <p v-if="hasError('country')" class="text-red-500 text-sm mt-1">
                        {{ getError('country') }}
                    </p>
                </div>


                <div>
                    <label for="image_upload" class="block text-sm font-medium text-gray-900 dark:text-white">
                        {{ $t("Location Image") }}
                    </label>
                    <div class="text-xs dark:text-neutral-200 mb-2">
                        {{ $t('Upload an image in PNG, JPEG, JPG, or WEBP format (max. 2MB)') }}
                    </div>
                    <input type="file" id="image_upload" @change="handleImageUpload"
                        accept="image/png, image/jpeg, image/jpg, image/webp" name="image_upload"
                        class="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg block w-full p-2.5 dark:bg-neutral-700 dark:border-neutral-600 dark:placeholder-gray-400 dark:text-white" />
                    <!-- Error message -->
                    <p v-if="hasError('image_upload')" class="text-red-500 text-sm mt-1">
                        {{ getError('image_upload') }}
                    </p>
                </div>


                <div>
                    <label for="logo_upload" class="block text-sm font-medium text-gray-900 dark:text-white">
                        {{ $t("Location Logo") }}
                    </label>
                    <div class="text-xs dark:text-neutral-200 mb-2">
                        {{ $t('Upload a logo in PNG, JPEG, JPG, or WEBP format (max. 2MB)') }}
                    </div>
                    <input type="file" id="logo_upload" @change="handleLogoUpload"
                        accept="image/png, image/jpeg, image/jpg, image/webp" name="logo_upload"
                        class="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg block w-full p-2.5 dark:bg-neutral-700 dark:border-neutral-600 dark:placeholder-gray-400 dark:text-white" />
                    <!-- Error message -->
                    <p v-if="hasError('logo_upload')" class="text-red-500 text-sm mt-1">
                        {{ getError('logo_upload') }}
                    </p>
                </div>

            </div>

            <div class="mb-6">
                <label for="description" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                    {{ $t("Location Description") }}
                </label>
                <small_text_editor textareaName="description"></small_text_editor>
                <!-- Error message -->
                <p v-if="hasError('description')" class="text-red-500 text-sm mt-1">
                        {{ getError('description') }}
                    </p>
            </div>



            <div class="flex items-center mb-6">
                <input id="tos" type="checkbox" v-model="form.tos" name="tos" required
                    class="w-[25px] h-[25px] text-primary bg-gray-100 border-gray-300 rounded-lg checked:bg-primary focus:ring-primary dark:focus:ring-primary dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
                <label for="tos" class="ms-2 text-sm font-medium text-gray-900 dark:text-neutral-300">
                    {{ $t("I agree with the") }}
                    <a :href="termsUrl" class="text-primary hover:underline dark:text-primary">
                        {{ $t("terms and conditions") }}.
                    </a>
                </label>
            </div>

            <div v-if="message.text" class="mb-4 text-red-400">
                {{ message.text }}
            </div>

            <button type="submit" :disabled="submitting"
                class="text-white bg-primary focus:ring-4 focus:outline-none font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center">
                {{ submitting ? $t("Submitting...") : $t("Submit") }}
            </button>
        </form>

        <div v-else class="">
            <div class="py-8">
                <div class="text-center">
                    <div
                        class="flex items-center justify-center w-20 h-20 mx-auto mb-6 bg-green-100 rounded-full dark:bg-green-700">
                        <svg class="h-12 w-12 text-green-600 dark:text-green-100" xmlns="http://www.w3.org/2000/svg"
                            fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true"
                            data-slot="icon">
                            <path stroke-linecap="round" stroke-linejoin="round"
                                d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"></path>
                        </svg>
                    </div>
                    <h1 class="text-4xl font-extrabold text-primary">
                        {{ message.text }}!
                    </h1>
                    <p class="mt-4 text-lg text-gray-800 dark:text-neutral-300">
                        {{
                            $t(
                                "Your location has been successfully received and is now under review by our team"
                            )
                        }}.
                    </p>

                    <p class="mt-4 text-sm text-gray-700 dark:text-neutral-400">
                        {{
                            $t(
                                "Once it has been checked and approved, it will appear on :app_url for everyone to see",
                                {
                                    app_url: $hostName,
                                }
                            )
                        }}.<br />
                        {{
                            $t(
                                "We will notify you if any additional information is needed"
                            )
                        }}.
                    </p>
                </div>
                <div class="mt-8 text-center">
                    <a :href="$baseUrl + '/locations'"
                        class="inline-block px-6 py-2 text-lg font-medium text-white transition-transform rounded-full bg-primary hover:scale-105 active:scale-90">
                        {{ $t("Back to Locations") }}
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
export default {
    data() {
        return {
            form: {
                name: "",
                street: "",
                maps_url: "",
                city: "",
                postcode: "",
                country: "",
                description: "",
                tos: false,
                default_name: "",
                lat: 0.000,
                long: 0.000,
                logo_upload: null,
                image_upload: null,

            },
            message: {
                text: "",
                type: "",
            },
            validationErrors: {},
            submitting: false,
            termsUrl: "/platform/terms",
        };
    },
    methods: {
        async submitForm() {
            if (this.submitting) return;
            this.submitting = true;

            try {
                // Set default_name to match name before submission
                this.form.default_name = this.form.name;

                const formData = new FormData();
                for (const key in this.form) {
                    if (key === "tos") {
                        formData.append(key, this.form[key] ? 1 : 0);
                    }
                    else if ((key === "logo_upload" || key === "image_upload")) {
                        if (this.form[key] instanceof File) {
                            formData.append(key, this.form[key]);
                        }
                        // ❌ DO NOT append anything if no file selected
                    }
                    else {
                        formData.append(key, this.form[key]);
                    }
                }

                const formElement = document.querySelector('#eventsForm');
                const inputs = formElement.querySelectorAll('input, textarea, select');

                inputs.forEach(input => {
                    const name = input.name;
                    if (!name) return; // skip inputs without a name

                    if (input.type === 'checkbox') {
                        formData.append(name, input.checked ? 1 : 0);
                    } else if (input.type === 'file') {
                        if (input.files.length > 0) {
                            formData.append(name, input.files[0]);
                        }
                        // ❌ do NOT append anything when empty
                        return;
                    } else {
                        formData.append(name, input.value);
                    }

                    // Update Vue form data if it exists
                    if (this.form.hasOwnProperty(name)) {
                        if (input.type === 'checkbox') {
                            this.form[name] = input.checked;
                        } else if (input.type === 'file') {
                            this.form[name] = input.files[0] || null;
                        } else {
                            this.form[name] = input.value;
                        }
                    }
                });

                await axios.get("/sanctum/csrf-cookie", {
                    withCredentials: true,
                });
                const response = await axios.post(
                    "/api/submitlocation",
                    formData,
                    { withCredentials: true }
                );
                this.message.text =
                    response.data.message || "Location submitted successfully!";
                this.message.type = "success";

                // Reset form
                for (const key in this.form) {
                    if (typeof this.form[key] === "boolean")
                        this.form[key] = false;
                    else this.form[key] = "";
                }
                this.validationErrors = {};
            } catch (error) {
                this.message.type = "error";

                if (error.response && error.response.data && error.response.data.errors) {
                    this.validationErrors = error.response.data.errors;
                    this.message.text = error.response.data.message ?? "Validation error.";
                } else {
                    this.message.text = "Something went wrong.";
                }
            } finally {
                this.submitting = false;
            }
        },
        handleImageUpload(event) {
            const file = event.target.files[0];
            if (file) this.form.image_upload = file;
        },
        handleLogoUpload(event) {
            const file = event.target.files[0];
            if (file) this.form.logo_upload = file;
        },

        hasError(field) {
            return this.validationErrors[field] !== undefined;
        },
        getError(field) {
            return this.validationErrors[field] ? this.validationErrors[field][0] : "";
        }


    },
};
</script>
